module.exports = __webpack_public_path__ + "img/pro_six.d29a3b01.jpg";